import React from 'react';
import { Check, Mail, HelpCircle, ShieldCheck, Lock, Star, PlayCircle } from 'lucide-react';
const CTAButton = ({
  className = ''
}: {
  className?: string;
}) => <div data-id="element-599">
    <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-g" className={`block w-full bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-4 px-4 rounded-lg text-center transition-colors shadow-lg ${className}`} data-id="element-600">
      <span className="block text-sm font-normal mb-1" data-id="element-601">Ga naar stap #2</span>
      <span className="block text-xl" data-id="element-602">Start de cursus nu</span>
    </a>
    <img src="https://cdn.magicpatterns.com/uploads/4vdV4HP3iomaCgiRo35kk3/ORAweI9onQltdmefOLBalrxDMg.png" alt="Betaalmethoden: Mastercard, CB, Apple Pay, iDEAL, SEPA, Visa, PayPal, American Express, Klarna, Bancontact" className="mx-auto mt-3 h-10 w-auto max-w-[280px] opacity-80" data-id="element-603" />
  </div>;
const PricingCard = () => <div className="bg-white rounded-xl shadow-xl p-6 border-t-8 border-[#5ce0d2] text-center flex flex-col h-full" data-id="element-604">
    <h3 className="text-[#5ce0d2] font-extrabold text-2xl mb-1 uppercase tracking-wide" data-id="element-605">
      Nu nog beschikbaar
    </h3>
    <h2 className="text-4xl font-black text-[#1a2b4a] mb-6" data-id="element-606">Start vandaag</h2>

    <div className="mb-6" data-id="element-607">
      <img src="https://cdn.magicpatterns.com/uploads/vxv92giZwb84avmwkmhTZx/Scherm­afbeelding_2026-04-12_om_21.51.15.png" alt="Liefdevol Communiceren Cursus - training op laptop, tablet en telefoon" className="w-full h-auto object-contain" data-id="element-608" />
    </div>

    <div className="text-[#e53e3e] font-black text-4xl mb-1" data-id="element-609">Nu voor €127</div>
    <div className="text-[#e53e3e] font-bold text-lg mb-6" data-id="element-610">(Bespaar €70)</div>

    <p className="text-sm text-gray-600 mb-6 leading-relaxed" data-id="element-611">
      Start met de Liefdevol Communiceren Cursus voor €127 in plaats van{' '}
      <span className="line-through" data-id="element-612">€197</span>. Per direct toegang. Start
      binnen de 3 minuten.
    </p>

    <p className="text-[#22c55e] font-bold text-sm mb-6" data-id="element-613">
      Nu beschikbaar voor directe toegang
    </p>

    <CTAButton className="mb-4" data-id="element-614" />

    <div className="text-xs text-gray-500 space-y-2 mt-auto pt-4" data-id="element-615">
      <p className="flex items-center justify-center gap-1" data-id="element-616">
        <Lock className="w-4 h-4" data-id="element-617" /> 100% veilig afrekenen
      </p>
      <p className="flex items-center justify-center gap-1" data-id="element-618">
        <ShieldCheck className="w-4 h-4" data-id="element-619" /> Met onze 100% geld terug garantie
      </p>
    </div>
  </div>;
export function LiefdevolCommunicerenACPage() {
  return <div className="min-h-screen bg-[#faf5eb] font-sans text-gray-800 pb-24 md:pb-0" data-id="element-620">
      {/* 1. HEADER */}
      <div className="bg-[#e6f7f5] py-3 px-4" data-id="element-621">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-622">
          <div className="flex-1 hidden md:block" data-id="element-623"></div>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-10 object-contain" data-id="element-624" />
          <div className="flex-1 flex justify-center md:justify-end" data-id="element-625">
            <a href="mailto:amee@stresslessdogs.nl" className="flex items-center text-sm font-bold text-[#1a2b4a] hover:text-[#5ce0d2] transition-colors" data-id="element-626">
              <Mail className="w-5 h-5 mr-2" data-id="element-627" />
              Hulp nodig? Mail mij op amee@stresslessdogs.nl
            </a>
          </div>
        </div>
      </div>

      {/* 2. BLACK BANNER */}
      <div className="bg-black text-white text-center py-4 px-4 font-bold text-sm md:text-base tracking-wide" data-id="element-628">
        Voor baasjes die eindelijk de verborgen taalbarrière met hun hond willen
        doorbreken (en een echte, diepe band willen opbouwen)
      </div>

      {/* 3. HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 md:py-16" data-id="element-629">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-[#1a2b4a] text-center mb-6 leading-tight" data-id="element-630">
          Jouw hond is niet 'koppig' of 'ongehoorzaam' - je spreekt zijn taal
          niet. Ontdek hoe je vloeiend de hondentaal leert spreken in 3 stappen.
        </h1>
        <p className="text-lg md:text-2xl text-center text-gray-700 mb-12 max-w-4xl mx-auto font-medium leading-relaxed" data-id="element-631">
          Zodat jij en je hond elkaar écht begrijpen, jullie samenwerken in
          plaats van botsen, en je eindelijk die ontspannen, liefdevolle band
          hebt waar je altijd van hebt gedroomd.
        </p>

        <div className="grid md:grid-cols-12 gap-8 items-start" data-id="element-632">
          <div className="md:col-span-8" data-id="element-633">
            <div className="rounded-xl overflow-hidden shadow-2xl bg-black border-4 border-white" data-id="element-634">
              <div style={{
              padding: '56.25% 0 0 0',
              position: 'relative'
            }} data-id="element-635">
                <iframe src="https://player.vimeo.com/video/1086787571?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="Hero Video" data-id="element-636"></iframe>
              </div>
            </div>
            <p className="text-center text-sm text-gray-500 mt-3 underline cursor-pointer" data-id="element-637">
              Klik op afspelen om de video te starten
            </p>

            {/* Wat is de nieuwe Verlatingsangst Kernaanpak? - direct under video */}
            <div className="mt-8" data-id="element-638">
              <h2 className="text-3xl font-bold text-[#5ce0d2] mb-4 text-center" data-id="element-639">
                Wat is de Liefdevol Communiceren Methode?
              </h2>
              <div className="text-lg text-gray-700 leading-relaxed space-y-4" data-id="element-640">
                <p data-id="element-641">
                  De Liefdevol Communiceren Methode is een stap voor stap aanpak
                  die hondenbaasjes helpt om de verborgen taal van hun hond te
                  leren lezen, te begrijpen en zelf vloeiend terug te spreken.
                </p>
                <p data-id="element-642">
                  We laten je precies zien hoe jouw hond de hele dag met je
                  communiceert via subtiele lichaamssignalen, en hoe jij op een
                  manier terugpraat die hij van nature begrijpt — zonder dwang,
                  straf of dominantie.
                </p>
                <p className="font-bold text-[#1a2b4a]" data-id="element-643">
                  Zodat jullie relatie niet gebaseerd is op gehoorzaamheid, maar
                  op wederzijds begrip en vertrouwen.
                </p>
              </div>
            </div>
          </div>

          <div className="md:col-span-4" data-id="element-644">
            <PricingCard data-id="element-645" />
          </div>
        </div>
      </section>

      {/* 6. VOOR WIE WERKT DIT */}
      <section className="max-w-4xl mx-auto px-4 py-12" data-id="element-646">
        {/* 6. VOOR WIE WERKT DIT */}
        <div className="bg-white rounded-xl shadow-md p-8 mb-12 border border-gray-100" data-id="element-647">
          <h3 className="text-2xl font-bold text-[#1a2b4a] mb-6" data-id="element-648">
            Voor wie werkt dit
          </h3>
          <p className="mb-6 text-gray-700" data-id="element-649">
            Voor alle baasjes die worstelen met gedragsproblemen en het gevoel
            hebben dat ze hun hond niet echt begrijpen:
          </p>
          <ul className="space-y-4" data-id="element-650">
            {['Het maakt niet uit als je nog nooit eerder iets hebt geleerd over hondentaal of lichaamssignalen.', 'De methode is eenvoudig en direct toepasbaar. Met slechts 30 minuten per dag zie je binnen een week al de eerste verbeteringen, en binnen twee tot vier weken ontstaat er een compleet nieuwe relatie.', 'Geschikt voor honden van alle leeftijden, rassen en formaten.', 'Werkt ook bij angstige honden, overprikkelde honden of honden met een rugzakje'].map((item, i) => <li key={i} className="flex items-start" data-id="element-651">
                <Check className="w-6 h-6 text-[#22c55e] mr-3 flex-shrink-0 mt-0.5" data-id="element-652" />
                <span className="text-gray-800 font-medium text-lg" data-id="element-653">
                  {item}
                </span>
              </li>)}
          </ul>

          {/* Desire Stack */}
          <div className="mt-8 pt-8 border-t border-gray-100" data-id="element-654">
            <h4 className="text-xl font-bold text-[#1a2b4a] mb-4" data-id="element-655">
              Stel je voor dat je straks…
            </h4>
            <ul className="space-y-3" data-id="element-656">
              {['Precies weet hoe je je hond op zijn gemak stelt als hij onrustig wordt - zonder te schreeuwen of te corrigeren.', 'Zijn stresssignalen herkent vóórdat het escaleert, zodat je hem kunt geruststellen op het moment dat hij het nodig heeft.', 'Ontspannen kunt wandelen zonder constant alert te zijn op andere honden of mensen.', "Zonder commando's communiceert met je hond, gewoon door je lichaamstaal - en hij begrijpt je meteen.", 'Visite kunt ontvangen zonder dat je hond door het lint gaat of dat jij je moet verontschuldigen.', 'Eindelijk die diepe, rustige band voelt waar je altijd van hebt gedroomd - elke dag opnieuw.'].map((item, i) => <li key={`desire-${i}`} className="flex items-start" data-id="element-657">
                  <Star className="w-5 h-5 text-[#ffb800] mr-3 flex-shrink-0 mt-0.5" data-id="element-658" />
                  <span className="text-gray-700 text-lg" data-id="element-659">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        {/* 7. MET DE METHODE */}
        <h3 className="text-2xl font-bold text-[#1a2b4a] mb-4" data-id="element-660">
          Met de Liefdevol Communiceren Methode…
        </h3>
        <div className="text-lg text-gray-700 leading-relaxed mb-12 space-y-4" data-id="element-661">
          <p data-id="element-662">
            ...leer je in drie stappen de taal van je hond te lezen én te
            spreken, zodat jullie eindelijk op één lijn zitten en
            gedragsproblemen vanzelf verminderen.
          </p>
          <p data-id="element-663">
            Waardoor je hond zich begrepen voelt en jullie samenwerking soepeler
            gaat dan je ooit voor mogelijk hield.
          </p>
          <p className="font-bold text-[#1a2b4a]" data-id="element-664">
            Geen frustratie meer dat je alles hebt geprobeerd maar niets werkt.
          </p>
        </div>

        <div className="mb-12 rounded-xl overflow-hidden shadow-lg" data-id="element-665">
          <img src="https://cdn.magicpatterns.com/uploads/vZLarCb4ynRSjgCisN7z8e/freepik_middelgrote-hond-in-een-g_2777443833.png" alt="Hond ontspannen op de bank terwijl baasje weggaat" className="w-full h-auto object-cover" data-id="element-666" />
        </div>

        {/* 8. SIGNALEN */}
        <div className="bg-[#e6f7f5] rounded-xl p-8 mb-12" data-id="element-667">
          <h3 className="text-2xl font-bold text-[#1a2b4a] mb-6" data-id="element-668">
            Herken jij dit bij jouw hond?
          </h3>
          <ul className="space-y-4" data-id="element-669">
            {['Springt tegen visite op, blaft de bezorger af, of wordt helemaal gek als er iemand aan de deur komt', 'Trekt als een bezetene aan de lijn of valt uit naar andere honden tijdens het wandelen', 'Pakt eten van tafel, luistert niet als je hem roept, of negeert je compleet in het park', 'Is constant druk in huis, kan niet tot rust komen op zijn plek, of volgt je overal naartoe', 'Reageert angstig op geluiden, nieuwe plekken of onbekende mensen - en jij weet niet hoe je hem gerust kunt stellen', 'Het gevoel dat je alles al hebt geprobeerd, maar dat jullie nog steeds langs elkaar heen leven'].map((item, i) => <li key={i} className="flex items-start" data-id="element-670">
                <Check className="w-6 h-6 text-[#5ce0d2] mr-3 flex-shrink-0 mt-0.5" data-id="element-671" />
                <span className="text-gray-800 font-medium text-lg" data-id="element-672">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </section>

      {/* 9. FULL WIDTH PRICING CTA */}
      <section className="bg-white py-16 border-y border-gray-200" data-id="element-673">
        <div className="max-w-4xl mx-auto px-4" data-id="element-674">
          <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-675">
            <div data-id="element-676">
              <h2 className="text-3xl font-black text-[#1a2b4a] mb-4" data-id="element-677">
                Start vandaag
              </h2>
              <div className="text-[#e53e3e] font-black text-4xl mb-1" data-id="element-678">
                Nu voor €127
              </div>
              <div className="text-[#e53e3e] font-bold text-lg mb-4" data-id="element-679">
                (Bespaar €70)
              </div>
              <p className="text-gray-600 mb-6" data-id="element-680">
                Start met de Liefdevol Communiceren Cursus voor €127 in plaats
                van <span className="line-through" data-id="element-681">€197</span>. Per direct
                toegang. Start binnen de 3 minuten.
              </p>
            </div>
            <div data-id="element-682">
              <CTAButton data-id="element-683" />
              <div className="text-xs text-gray-500 space-y-2 mt-4 text-center" data-id="element-684">
                <p className="flex items-center justify-center gap-1" data-id="element-685">
                  <Lock className="w-4 h-4" data-id="element-686" /> 100% veilig afrekenen
                </p>
                <p className="flex items-center justify-center gap-1" data-id="element-687">
                  <ShieldCheck className="w-4 h-4" data-id="element-688" /> Met onze 100% geld terug
                  garantie
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 10. DETAILED EXPLANATION + SIDEBAR */}
      <section className="max-w-7xl mx-auto px-4 py-16" data-id="element-689">
        <div className="grid lg:grid-cols-12 gap-8" data-id="element-690">
          {/* Left column - main content */}
          <div className="lg:col-span-8" data-id="element-691">
            <h2 className="text-3xl font-bold text-[#5ce0d2] mb-6" data-id="element-692">
              Wat is de Liefdevol Communiceren Methode?
            </h2>
            <div className="text-lg text-gray-700 leading-relaxed mb-12 space-y-4" data-id="element-693">
              <p data-id="element-694">
                Commanderen heeft pas zin als je eerst dezelfde taal spreekt als
                je hond.
              </p>
              <p data-id="element-695">
                Doe je dat niet, dan blijft er een onzichtbare muur tussen
                jullie staan. Je hond doet wat hij wil, en jij begrijpt niet
                waarom. Want jullie spreken letterlijk een andere taal.
              </p>
              <p data-id="element-696">
                Jouw hond communiceert de hele dag subtiele signalen. Dat je die
                soms mist, is niet jouw schuld. De ouderwetse
                hondensportindustrie heeft ons decennialang verteld dat honden
                gewoon moeten 'luisteren', in plaats van ons te leren hoe we hun
                taal kunnen lezen.
              </p>
              <p data-id="element-697">
                Oude trainingsmethodes laten je geloven dat je hond 'koppig' of
                'dominant' is, terwijl hij in werkelijkheid gewoon beleefd of
                onbegrepen is. Zodra je zijn ware taal spreekt, valt die
                frustratie direct weg.
              </p>
              <p className="font-medium" data-id="element-698">
                Daarom moet je eerst de taalbarrière doorbreken. Dit is hoe het
                werkt.
              </p>
            </div>

            {/* 11. 3 STEPS */}
            <div className="mb-8 rounded-xl overflow-hidden" data-id="element-699">
              <img src="https://cdn.magicpatterns.com/uploads/gZydPdwYJ47daE8nNYhLdq/9b6d1fe9789894c2655050948709230b.png" alt="Oude Aanpak vs De Liefdevol Communiceren Methode" className="w-full h-auto object-contain rounded-lg" data-id="element-700" />
            </div>
            <h2 className="text-3xl font-bold text-[#1a2b4a] mb-8 text-center" data-id="element-701">
              De taalbarrière doorbreken in drie stappen
            </h2>
            <div className="space-y-8 mb-16" data-id="element-702">
              {[{
              title: 'Stap 1: Hondentaal',
              text: 'De eerste stap is de taal van je hond leren. Je hond communiceert de hele dag via subtiele lichaamssignalen. In stap 1 leer je deze signalen herkennen en begrijpen, zodat je eindelijk weet wat je hond je probeert te vertellen.'
            }, {
              title: 'Stap 2: Terugpraten',
              text: 'De tweede stap is zelf in die taal terugpraten. Je leert hoe je met handgebaren en kalmerende signalen communiceert op een manier die je hond van nature begrijpt. Geen geschreeuw, geen straffen — gewoon duidelijke, liefdevolle communicatie die hij meteen oppikt.'
            }, {
              title: 'Stap 3: Samenwerken',
              text: 'En dan, als jullie dezelfde taal spreken… Ga je als derde stap écht samenwerken. Niet meer commanderen en gehoorzamen, maar een gelijkwaardige samenwerking gebaseerd op begrip en vertrouwen. Gedragsproblemen lossen zichzelf op, want de oorzaak — miscommunicatie — is verdwenen.'
            }].map((step, i) => <div key={i} className="flex gap-6 items-start" data-id="element-703">
                  <div className="w-12 h-12 rounded-full bg-[#5ce0d2] text-white flex items-center justify-center font-bold text-2xl flex-shrink-0 mt-1" data-id="element-704">
                    {i + 1}
                  </div>
                  <div data-id="element-705">
                    <p className="text-lg text-gray-700 leading-relaxed" data-id="element-706">
                      {step.text}
                    </p>
                  </div>
                </div>)}
            </div>
            <p className="text-lg text-gray-700 leading-relaxed mb-4 font-medium" data-id="element-707">
              Op deze manier kan zelfs een hond die al jaren uitvalt, blaft of
              trekt leren om rustig en ontspannen te zijn — omdat hij zich
              eindelijk begrepen voelt en jij eindelijk begrijpt wat hij nodig
              heeft.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-8 font-medium" data-id="element-708">
              Zonder frustratie, zonder straffen, zonder dominantie.
            </p>

            <div className="mb-16 rounded-xl overflow-hidden shadow-lg" data-id="element-709">
              <img src="https://cdn.magicpatterns.com/uploads/c5dwivjBuf94wiUeGKtu3j/freepik_man-en-vrouw-van-rond-de-_2777480988.png" alt="Man en vrouw verlaten ontspannen hun huis met hond op de achtergrond" className="w-full h-auto object-cover" data-id="element-710" />
            </div>

            {/* 12. ICEBERG */}
            <div className="bg-[#1a2b4a] text-white rounded-2xl p-8 md:p-12 mb-16 shadow-2xl" data-id="element-711">
              <h2 className="text-3xl font-bold text-[#5ce0d2] mb-8 text-center" data-id="element-712">
                Waarom deze methode werkt juist als nog niks gewerkt heeft
              </h2>
              <div className="flex items-center gap-5 mb-10 max-w-2xl mx-auto" data-id="element-713">
                <blockquote className="text-xl italic text-gray-300 border-l-4 border-[#5ce0d2] pl-4 flex-1" data-id="element-714">
                  "Meestal zijn wij, de menselijke soort, degenen die conflicten
                  creëren tussen onze honden en onszelf." - Turid Rugaas
                </blockquote>
                <img src="https://cdn.magicpatterns.com/uploads/qmwWHyfVMxLgrevSP4D47H/sigmund.jpg" alt="Turid Rugaas" className="w-20 h-20 rounded-full object-cover flex-shrink-0 border-2 border-[#5ce0d2]" data-id="element-715" />
              </div>

              <div className="space-y-6 text-gray-200 text-lg leading-relaxed" data-id="element-716">
                <p data-id="element-717">
                  Het blaffen, trekken of uitvallen is maar een klein deel van
                  wat er bij je hond gebeurt. Hij laat dit gedrag zien omdat hij
                  zich onbegrepen voelt. Deze frustratie is een logische
                  reactie. Deze reactie wordt veroorzaakt omdat jullie
                  letterlijk langs elkaar heen praten. Dit zien we niet direct,
                  maar deze miscommunicatie bepaalt al zijn emoties en
                  gedragingen.
                </p>
                <p data-id="element-718">
                  Je kan het eigenlijk zien als een ijsberg in de zee. Het
                  blaffen, trekken en gedrag dat wij "ongehoorzaamheid" noemen
                  is wat je ziet. Dit is de <strong data-id="element-719">10% van de ijsberg</strong>{' '}
                  die boven water drijft.
                </p>
                <p data-id="element-720">
                  Dan zijn er zijn emoties en de frustratie die hij ervaart. Als
                  je goed kijkt kan je dit herkennen. Dit is het deel onderwater
                  wat je nog kan zien. Dit is nog eens <strong data-id="element-721">30%</strong>.
                </p>
                <p data-id="element-722">
                  Dan ligt er diep onderwater nog een heel groot deel van de
                  ijsberg. Dit is de verborgen taal van je hond en zijn behoefte
                  om begrepen te worden. Bij gedragsproblemen is er hier een
                  taalbarrière. Dit is nog eens <strong data-id="element-723">60%</strong> van wat er
                  eigenlijk aan de hand is.
                </p>
                <p className="font-bold text-white" data-id="element-724">
                  Als je gedragsproblemen wilt aanpakken dan moet je aan de slag
                  met de hele ijsberg. Niet alleen met het zichtbare gedrag.
                </p>
                <p data-id="element-725">
                  Dus als je de taalbarrière niet doorbreekt dan heeft
                  commanderen maar 10% van het effect dat je wilt. Dat is waarom
                  trainen zo langzaam gaat en je hond snel terugvalt in oud
                  gedrag. Het is dan alsof je de ijsberg even onder water hebt
                  geduwd en hij weer boven komt. Dit is wat andere methodes
                  verkeerd doen. Ze beginnen direct met commando's en
                  correcties. Daarom gaat het langzaam, blijft je hond
                  terugvallen in gedrag en vindt er geen echte verandering
                  plaats.
                </p>
                <div className="mt-8 rounded-xl overflow-hidden" data-id="element-726">
                  <img src="https://cdn.magicpatterns.com/uploads/dp1MNNz2c1oFtFSZvJECoy/7db3c11805f8570f0b6c849247d8d1b4.jpg" alt="Verlatingsangst IJsberg Theorie" className="w-full h-auto object-contain rounded-lg" data-id="element-727" />
                </div>
              </div>
            </div>

            {/* 13. ZO PAS JE HET TOE */}
            <h2 className="text-3xl font-bold text-[#1a2b4a] mb-6" data-id="element-728">
              Zo pas je de Liefdevol Communiceren Methode vandaag nog toe
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-6" data-id="element-729">
              De Liefdevol Communiceren Methode wordt alleen door onze coaches
              gebruikt tijdens onze behandeltrajecten. Niemand in Nederland
              werkt nog op deze manier. Maar wij vinden dat ieder hondenbaasje
              dat worstelt met de gedragsproblemen van zijn hond de kans zou
              moeten krijgen om hiermee aan de slag te gaan.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-12" data-id="element-730">
              Daarom hebben we een videotraining gemaakt voor je. In deze
              training doorlopen we in drie compacte lessen ieder van de drie
              essentiële stappen in deze aanpak.
            </p>

            <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-731">
              {[{
              title: 'Stap 1',
              text: 'Na stap 1 begrijp je de subtiele lichaamssignalen van je hond en hoe je deze leest, zodat je zeker weet wat hij je probeert te vertellen.'
            }, {
              title: 'Stap 2',
              text: 'Na stap 2 snap je hoe je met handgebaren en kalmerende signalen terugpraat, zodat je hond zich begrepen voelt en klaar is voor stap 3.'
            }, {
              title: 'Stap 3',
              text: 'En na stap 3 snap je hoe jullie als een team kunnen samenwerken, zodat gedragsproblemen vanzelf verdwijnen.'
            }].map((les, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-md border-t-4 border-[#5ce0d2]" data-id="element-732">
                  <h4 className="font-bold text-xl text-[#1a2b4a] mb-3" data-id="element-733">
                    {les.title}
                  </h4>
                  <p className="text-gray-600 text-sm leading-relaxed" data-id="element-734">
                    {les.text}
                  </p>
                </div>)}
            </div>
            <p className="text-center font-bold text-gray-500 mb-16" data-id="element-735">
              Zet vandaag nog de eerste stap.
            </p>
          </div>

          {/* Right column - sticky sidebar */}
          <div className="hidden lg:block lg:col-span-4" data-id="element-736">
            <div className="sticky top-8" data-id="element-737">
              <div className="bg-white rounded-xl overflow-hidden shadow-xl border border-gray-200" data-id="element-738">
                {/* BIJ JE BESTELLING */}
                <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-black text-sm uppercase tracking-widest" data-id="element-739">
                  BIJ JE BESTELLING
                </div>

                <div className="p-5" data-id="element-740">
                  {/* Product */}
                  <div className="flex gap-4 items-start mb-6" data-id="element-741">
                    <img src="https://cdn.magicpatterns.com/uploads/bPH8swctNa91LRo7t5rtnE/Verlatingangst_kernmethode_bonus_(3).png" alt="Liefdevol Communiceren - Cursus" className="w-20 h-20 object-cover rounded-lg flex-shrink-0" data-id="element-742" />
                    <div data-id="element-743">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-744">
                        LIEFDEVOL COMMUNICEREN - CURSUS
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-745">
                        Gedetailleerde uitleg van hoe je de verborgen
                        taalbarrière in 3 stappen doorbreekt en een diepe band
                        opbouwt
                      </p>
                    </div>
                  </div>

                  {/* 5 FREE FAST ACTION BONUSES */}
                  <div className="bg-[#1a2b4a] text-white text-center py-2 px-3 font-black text-xs uppercase tracking-widest rounded-md mb-5" data-id="element-746">
                    3 x GRATIS BONUS
                  </div>

                  {/* Bonus 1 */}
                  <div className="flex gap-3 items-start mb-5" data-id="element-747">
                    <img src="https://cdn.magicpatterns.com/uploads/kK8kyQqoZHm31F5VUdBjhD/2.png" alt="30 Dagen Community Toegang" className="w-16 h-16 object-cover rounded-lg flex-shrink-0" data-id="element-748" />
                    <div data-id="element-749">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-750">
                        30 DAGEN COMMUNITY TOEGANG
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-751">
                        Stuur vragen, foto's en videos naar onze experts, neem
                        deel aan meerdere wekelijkse online coachingsessies en
                        kom in contact met andere hondenbaasjes.
                      </p>
                    </div>
                  </div>

                  {/* Bonus 2 */}
                  <div className="flex gap-3 items-start mb-5" data-id="element-752">
                    <img src="https://cdn.magicpatterns.com/uploads/jpptdiaLg8Jy3uMEh1EZiz/3.png" alt="Printbare Stappenplannen" className="w-16 h-16 object-cover rounded-lg flex-shrink-0" data-id="element-753" />
                    <div data-id="element-754">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-755">
                        Printbare Stappenplannen
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-756">
                        Handige, printbare overzichten van alle lichaamssignalen
                        en kalmerende signalen om er altijd bij te kunnen
                        pakken.
                      </p>
                    </div>
                  </div>

                  {/* Bonus 3 */}
                  <div className="flex gap-3 items-start mb-6" data-id="element-757">
                    <img src="https://cdn.magicpatterns.com/uploads/bbcA4WNP4wTigQiHJcajRX/4.png" alt="Levenslange Toegang" className="w-16 h-16 object-cover rounded-lg flex-shrink-0" data-id="element-758" />
                    <div data-id="element-759">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-760">
                        Levenslange Toegang
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-761">
                        Je krijgt levenslange toegang tot al het lesmateriaal,
                        inclusief alle toekomstige updates van de cursus.
                      </p>
                    </div>
                  </div>

                  {/* RESULTATEN */}
                  <div className="bg-[#1a2b4a] text-white text-center py-2 px-3 font-black text-xs uppercase tracking-widest rounded-md mb-4" data-id="element-762">
                    RESULTATEN VAN DE METHODE
                  </div>

                  {/* Vimeo video */}
                  <div className="rounded-lg overflow-hidden" data-id="element-763">
                    <div style={{
                    padding: '56.25% 0 0 0',
                    position: 'relative'
                  }} data-id="element-764">
                      <iframe src="https://player.vimeo.com/video/1158372685?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%'
                    }} title="Resultaten video" data-id="element-765"></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 16. LETTER SECTION */}
      <section className="bg-white py-16" data-id="element-766">
        <div className="max-w-6xl mx-auto px-4" data-id="element-767">
          {/* Section headline */}
          <h2 className="text-3xl md:text-4xl font-black text-[#1a2b4a] text-center mb-4" data-id="element-768">
            RESULTATEN VAN DE METHODE
          </h2>
          <p className="text-center text-lg text-gray-700 max-w-3xl mx-auto mb-8" data-id="element-769">
            Dit is hoe ik hondenbaasjes help om de taalbarrière te doorbreken
            door eerst de hondentaal te leren, dit maakt de verdere samenwerking
            veel en veel makkelijker
          </p>

          <p className="text-xl font-bold text-[#5ce0d2] mb-12 text-center leading-relaxed max-w-3xl mx-auto" data-id="element-770">
            Deze aanpak is nieuw, compleet anders, en verschilt van de eerdere
            aanpakken die je tot nu toe kent - lees mijn verhaal hieronder over
            het ontstaan van de Liefdevol Communiceren Methode
          </p>

          <div className="grid lg:grid-cols-12 gap-8" data-id="element-771">
            {/* Left column - letter content */}
            <div className="lg:col-span-8" data-id="element-772">
              <div className="bg-[#faf5eb] rounded-2xl p-8 md:p-12 shadow-sm border border-gray-100" data-id="element-773">
                <div className="prose prose-lg max-w-none text-gray-800" data-id="element-774">
                  <p className="font-bold" data-id="element-775">Beste hondenbaasje,</p>
                  <p data-id="element-776">
                    <strong data-id="element-777">Van:</strong> Amee de Bruijn
                  </p>
                  <p data-id="element-778">
                    <strong data-id="element-779">Re:</strong> De enige manier om gedragsproblemen
                    écht op te lossen, is door de taal van je hond te spreken
                    (en niet door te commanderen).
                  </p>
                  <p data-id="element-780">
                    Misschien verbaast het je dat er een andere manier is dan
                    eindeloos corrigeren waarmee je gedragsproblemen sneller
                    kunt oplossen, met een minimale kans op terugval.
                  </p>
                  <p data-id="element-781">En dat is niet gek.</p>
                  <p data-id="element-782">
                    Want bijna alles wat je online vindt, draait om
                    symptoombestrijding: commando's, correcties, je hond
                    domineren, of afleiden met snoepjes.
                  </p>
                  <p data-id="element-783">
                    Geen van deze methodes focust zich op het échte,
                    onderliggende probleem.
                  </p>
                  <p data-id="element-784">
                    Waarom zou mijn verhaal dan wel waar zijn? Je kunt immers
                    niet alles geloven wat je op het internet leest.
                  </p>
                  <p className="font-bold text-xl text-[#1a2b4a] mt-8" data-id="element-785">
                    Dus laat het me je bewijzen.
                  </p>
                  <div className="bg-white p-6 rounded-lg my-8 text-sm italic text-gray-600 border-l-4 border-gray-300" data-id="element-786">
                    <strong data-id="element-787">Maar lees eerst deze disclaimer:</strong> Ik heb het
                    voordeel van jarenlange ervaring en het doorbreken van oude
                    methodes. De gemiddelde persoon die een "zo-doe-je-dat"
                    methode volgt, behaalt weinig tot geen resultaten. Jouw
                    resultaten zijn afhankelijk van vele factoren, waaronder
                    vooral je bereidheid om te doen wat er in de methode staat.
                    Elke verandering vraagt om inzet en doorzettingsvermogen.
                    Als je daar niet toe bereid bent, dan is deze methode
                    misschien niet voor jou. Met dat gezegd, laat me je laten
                    zien hoe het anders kan.
                  </div>

                  <p className="font-bold text-2xl text-[#1a2b4a] mt-12 mb-6" data-id="element-788">
                    Ik werk met een compleet andere methode die ik nu met jou ga
                    delen.
                  </p>
                  <p data-id="element-789">
                    Dit is dezelfde Liefdevol Communiceren Methode die honderden
                    hondeneigenaren nu gebruiken om de paniek bij hun hond écht
                    op te lossen.
                  </p>
                  <p data-id="element-790">
                    Hierdoor krijgen zij een ontspannen hond terug, sneller dan
                    ze ooit voor mogelijk hielden.
                  </p>
                  <p data-id="element-791">
                    En het mooiste van alles? Ze bouwen een diepere, betere band
                    op met hun hond, gebaseerd op begrip in plaats van
                    frustratie.
                  </p>
                  <p className="font-bold" data-id="element-792">
                    Dit is niet zomaar een stappenplan;
                  </p>
                  <p data-id="element-793">
                    Het is een fundamenteel andere manier van denken over
                    verlatingsangst. We focussen ons niet op:
                  </p>
                  <ul className="list-disc pl-6 mb-6 space-y-2" data-id="element-794">
                    <li data-id="element-795">
                      Eindeloze gehoorzaamheidstrainingen die nergens toe
                      leiden.
                    </li>
                    <li data-id="element-796">
                      Je hond straffen of corrigeren als hij iets 'fout' doet.
                    </li>
                    <li data-id="element-797">Trucjes om je hond af te leiden met voer.</li>
                    <li data-id="element-798">
                      Standaard protocollen die geen rekening houden met jouw
                      unieke hond.
                    </li>
                  </ul>
                  <p className="font-bold text-xl text-[#5ce0d2] p-6 bg-[#e6f7f5] rounded-lg my-8" data-id="element-799">
                    In plaats daarvan doen we iets wat bijna niemand doet: we
                    beginnen met het leren van de taal van de hond om de échte
                    oorzaak te begrijpen.
                  </p>
                  <p data-id="element-800">
                    Dit is een compleet andere aanpak, en het heeft de kracht om
                    alles voor jou en je hond te veranderen. Ik weet dat dit
                    waar is, want het heeft alles voor mij veranderd.
                  </p>

                  <h3 className="text-2xl font-bold text-[#1a2b4a] mt-12 mb-6" data-id="element-801">
                    Hoe ik dit ontdekte: De "Muur van Onbegrip" bij mijn klanten
                  </h3>
                  <p data-id="element-802">
                    Als gedragsdeskundige zag ik dit patroon steeds terugkomen
                    bij mijn klanten. Ik noem het de "Muur van Onbegrip":
                  </p>
                  <div className="bg-white border border-gray-200 rounded-lg p-6 my-6 space-y-3 shadow-sm" data-id="element-803">
                    <p data-id="element-804">
                      <strong data-id="element-805">Stap 1:</strong> Ze volgden online adviezen en
                      begonnen met strenge commando's en correcties.
                    </p>
                    <p data-id="element-806">
                      <strong data-id="element-807">Stap 2:</strong> De hond luisterde niet, dus ze
                      werden strenger. Meer correcties.
                    </p>
                    <p data-id="element-808">
                      <strong data-id="element-809">Stap 3:</strong> Na een week leek de hond even te
                      luisteren uit angst. Een klein succes!
                    </p>
                    <p data-id="element-810">
                      <strong data-id="element-811">Stap 4:</strong> Ze kwamen in een nieuwe situatie,
                      en de hond viel weer net zo hard uit.
                    </p>
                    <p data-id="element-812">
                      <strong data-id="element-813">Stap 5:</strong> Mensen op straat keken boos. Ze
                      voelden zich slechte eigenaren.
                    </p>
                    <p data-id="element-814">
                      <strong data-id="element-815">Stap 6:</strong> Ze gaven het op en vermeden
                      drukke plekken en andere honden.
                    </p>
                    <p data-id="element-816">
                      <strong data-id="element-817">Stap 7:</strong> Na een paar weken frustratie
                      begonnen ze weer bij Stap 1.
                    </p>
                  </div>
                  <p data-id="element-818">
                    Ik zag hoe deze cirkel mijn klanten jarenlang gevangen
                    hield. Ze voelden zich machteloos en schuldig.
                  </p>
                  <p data-id="element-819">
                    Ik voelde me gefrustreerd omdat ik zag dat ik hen niet echt
                    hielp. Ik was aan het symptoombestrijden, niet aan het
                    oplossen.
                  </p>
                  <p data-id="element-820">
                    Ik stond op het punt om te geloven dat sommige honden gewoon
                    onhandelbaar waren.
                  </p>
                  <p data-id="element-821">
                    Maar voordat ik dit opgaf, wilde ik nog één ding proberen.
                    Iets wat, als het zou werken, alles zou veranderen.
                  </p>
                  <p className="font-bold" data-id="element-822">En het werkte.</p>

                  <div className="my-12 flex flex-col md:flex-row gap-8 items-center" data-id="element-823">
                    <img src="https://cdn.magicpatterns.com/uploads/vXmyJc5cCVvbLnBaXGCixn/682f298cbb713_AmeemetSophietje1.png" alt="Amee de Bruijn" className="w-48 h-48 rounded-full object-cover shadow-xl border-4 border-white" data-id="element-824" />
                    <div data-id="element-825">
                      <h3 className="text-2xl font-bold text-[#1a2b4a] mb-4" data-id="element-826">
                        Mijn naam is Amee, en ik zag jouw frustratie bij al mijn
                        klanten.
                      </h3>
                      <div className="space-y-4" data-id="element-827">
                        <p className="text-sm text-[#5ce0d2] font-bold uppercase tracking-wide" data-id="element-828">
                          Gediplomeerd Hondengedragsconsultant & Natural Dog
                          Trainer (niveau 5, Calming Signs, 2017)
                        </p>
                        <p data-id="element-829">
                          Als gedragsdeskundige zag ik steeds dezelfde pijn.
                          Honden die ondanks alle liefde en zorg onbegrepen
                          bleven en daardoor probleemgedrag lieten zien.
                        </p>
                        <p data-id="element-830">
                          Eigenaren, vooral vrouwen van 50+, die hun hele leven
                          om hun hond heen planden.
                        </p>
                        <p data-id="element-831">
                          Geen ontspannen wandeling meer, altijd die knoop in je
                          maag als je een andere hond tegenkwam.
                        </p>
                        <p data-id="element-832">
                          Na jarenlange ervaring met honderden honden en hun
                          baasjes, en een specialisatie in kalmerende signalen
                          en hondenlichaamstaal, ontwikkelde ik een methode die
                          niet draait om gehoorzaamheid, maar om écht begrip.
                        </p>
                      </div>
                    </div>
                  </div>

                  <p data-id="element-833">
                    Ze voelden zich gevangen in hun eigen huis, schuldig
                    tegenover hun hond, en bezwaard naar de omgeving die altijd
                    moest bijspringen.
                  </p>
                  <p data-id="element-834">
                    En ik zag dat mijn standaard aanpak hen niet echt hielp.
                  </p>
                  <p data-id="element-835">
                    Het keerpunt kwam bij een klant met een hond die meerdere
                    problemen had. We kregen het gedrag niet opgelost met de
                    standaard aanpak.
                  </p>
                  <p data-id="element-836">
                    Pas toen we stopten met commanderen en begonnen met
                    luisteren naar zijn signalen – gebeurde er iets magisch. Het
                    probleemgedrag verdween daarna als sneeuw voor de zon.
                  </p>
                  <p data-id="element-837">
                    Het was een Eureka-moment. Ineens viel alles op zijn plek.
                  </p>
                  <p className="font-bold text-xl text-[#1a2b4a] my-6" data-id="element-838">
                    Ongehoorzaamheid was niet het probleem; het was een
                    symptoom.
                  </p>
                  <p data-id="element-839">En dat veranderde alles in hoe ik werkte.</p>

                  <h3 className="text-2xl font-bold text-[#1a2b4a] mt-12 mb-6" data-id="element-840">
                    De #1 Fout die iedereen maakt: focussen op het symptoom
                  </h3>
                  <p data-id="element-841">
                    De markt voor hondentraining is verdeeld in twee kampen. Je
                    hebt de "symptoombestrijders" en je hebt ons van Stressless
                    Dogs, wij zijn de "kernaanpakkers".
                  </p>
                  <p data-id="element-842">
                    Maar jarenlang was ik ook een symptoombestrijder. Ik
                    probeerde mijn klanten te helpen door het blaffen, piepen en
                    slopen af te leren.
                  </p>
                  <p data-id="element-843">
                    Maar het probleem is niet het gedrag zelf. Het probleem is
                    de onderliggende emotie die het gedrag veroorzaakt.
                  </p>
                  <p className="font-bold text-red-600" data-id="element-844">
                    Het gevaarlijkste advies dat je kunt krijgen, is "gewoon
                    oefenen en laten wennen".
                  </p>
                  <p data-id="element-845">
                    Waarom? Omdat je daarmee de onderliggende stress negeert.
                  </p>
                  <p data-id="element-846">
                    Soms verergert het de situatie zelfs, waardoor de stress
                    overslaat op andere aspecten van het leven van je hond. Je
                    bent de paniek aan het managen, niet aan het oplossen.
                  </p>
                  <p data-id="element-847">
                    De oplossing gaat tegen je gevoel in: stop met focussen op
                    het oefenen van alleen zijn. In plaats daarvan richten we
                    ons op de wortel van het probleem.
                  </p>
                  <p data-id="element-848">
                    Is het angst? Pijn? Frustratie? Of gewoon pure
                    miscommunicatie?
                  </p>
                  <p className="font-bold" data-id="element-849">
                    Zodra je de taalbarrière doorbreekt en de communicatie
                    herstelt, wordt de samenwerking verrassend eenvoudig en
                    effectief.
                  </p>

                  <h3 className="text-2xl font-black text-[#1a2b4a] mt-12 mb-8" data-id="element-850">
                    Wat je leert in deze training:
                  </h3>
                  <div className="space-y-6 not-prose" data-id="element-851">
                    {[{
                    title: 'Stap 1: Hondentaal',
                    text: 'Leer de subtiele lichaamssignalen van je hond en hoe je ontdekt wat hij je precies probeert te vertellen.'
                  }, {
                    title: 'Stap 2: Terugpraten',
                    text: 'Krijg de tools om in zijn eigen taal terug te communiceren en een sterke, veerkrachtige vertrouwensband te leggen.'
                  }, {
                    title: 'Stap 3: Samenwerken',
                    text: 'Leer hoe je stressvrij en effectief kunt samenwerken, op een manier die past bij jouw hond, zodat je snel en blijvend resultaat boekt.'
                  }].map((les, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-gray-200 flex gap-4 items-start" data-id="element-852">
                        <PlayCircle className="w-8 h-8 text-[#5ce0d2] flex-shrink-0 mt-1" data-id="element-853" />
                        <div data-id="element-854">
                          <h4 className="font-bold text-xl text-[#1a2b4a] mb-2" data-id="element-855">
                            {les.title}
                          </h4>
                          <p className="text-gray-700 m-0" data-id="element-856">{les.text}</p>
                        </div>
                      </div>)}
                  </div>
                  <p className="text-gray-600 mt-8 italic" data-id="element-857">
                    Daarnaast krijg je toegang tot casestudies en interviews met
                    klanten, zodat je precies ziet hoe deze aanpak in de
                    praktijk werkt.
                  </p>

                  <h3 className="text-2xl font-bold text-[#1a2b4a] mt-12 mb-6" data-id="element-858">
                    Voor wie is deze methode (niet)?
                  </h3>
                  <p data-id="element-859">
                    Deze methode is <strong data-id="element-860">niet</strong> voor mensen die hun
                    hond zien als een robot die moet gehoorzamen. Het is niet
                    voor mensen die een snelle, magische oplossing zoeken zonder
                    bereid te zijn hun hond echt te begrijpen.
                  </p>
                  <p data-id="element-861">
                    Deze methode is <strong data-id="element-862">voor jou</strong> als je je hond
                    ziet als een volwaardig gezinslid. Als je gelooft dat hij
                    emoties en gevoelens heeft die gerespecteerd moeten worden.
                    En als je bereid bent om het anders te doen, op een manier
                    die op de lange termijn beter is voor zowel jou als je hond.
                  </p>
                  <p className="text-xl font-bold text-[#5ce0d2] mt-8 mb-12" data-id="element-863">
                    Als je klaar bent om de cirkel van wanhoop te doorbreken en
                    je vrijheid terug te krijgen, dan is dit het moment. Stop
                    met symptoombestrijding en start met de kernaanpak.
                  </p>

                  <div className="rounded-xl overflow-hidden shadow-lg mt-8" data-id="element-864">
                    <img src="https://cdn.magicpatterns.com/uploads/bEbEj36tRb2txwLv3vaAfN/freepik_man-en-vrouw-van-rond-de-_2777484675.png" alt="Man en vrouw kijken naar ontspannen hond" className="w-full h-auto object-cover" data-id="element-865" />
                  </div>
                </div>
              </div>
            </div>

            {/* Right column - sticky sidebar */}
            <div className="lg:col-span-4" data-id="element-866">
              <div className="lg:sticky lg:top-8 space-y-6" data-id="element-867">
                {/* Product image */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-868">
                  <img src="https://cdn.magicpatterns.com/uploads/wdHvRUEhLbVnqomgf29M7C/d2e92536bec5d1aca3fcae847f833a85.jpg" alt="Liefdevol Communiceren Cursus Training op verschillende apparaten" className="w-full h-auto object-contain" data-id="element-869" />
                </div>

                {/* Wat je krijgt */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-870">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-871">
                    Dit is wat je krijgt met de training
                  </div>
                  <div className="p-5 space-y-5" data-id="element-872">
                    <div className="flex items-start gap-3" data-id="element-873">
                      <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-874" />
                      <span className="text-sm font-bold text-gray-800" data-id="element-875">
                        Drie stappen kernaanpak om jouw hond te leren alleen
                        thuis te blijven
                      </span>
                    </div>

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-876">
                      Dit leer je in Stap 1
                    </p>
                    {['Hoezo commanderen geen nut heeft als je niet eerst dezelfde taal spreekt', 'Welke subtiele lichaamssignalen honden gebruiken en wat ze precies betekenen', 'Hoe je de signalen van jouw hond leest zodat je weet wat hij nodig heeft'].map((item, i) => <div key={`l1-${i}`} className="flex items-start gap-3" data-id="element-877">
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-878" />
                        <span className="text-sm text-gray-700" data-id="element-879">{item}</span>
                      </div>)}

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-880">
                      Dit leer je in Stap 2
                    </p>
                    {['Hoe je kalmerende signalen en handgebaren gebruikt om terug te praten', 'Wat je wel, en wat je juist niet moet doen met je lichaamstaal om misverstanden te voorkomen', 'Voorbeeld casus van hond Lemmy en hoe hij van extreem uitvallen naar ontspannen wandelen ging met deze methode', 'Voorbeeld casus van honden Mork & Dash en hoe zij hun frustratie in korte tijd overwonnen met deze methode'].map((item, i) => <div key={`l2-${i}`} className="flex items-start gap-3" data-id="element-881">
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-882" />
                        <span className="text-sm text-gray-700" data-id="element-883">{item}</span>
                      </div>)}

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-884">
                      Dit leer je in Stap 3
                    </p>
                    {['Effectief samenwerken zodat je op de juiste manier een diepe band opbouwt', 'Drie voorbeeld situaties waarin je de methode in de praktijk brengt'].map((item, i) => <div key={`l3-${i}`} className="flex items-start gap-3" data-id="element-885">
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-886" />
                        <span className="text-sm text-gray-700" data-id="element-887">{item}</span>
                      </div>)}

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-888">
                      Dit leer je in de bonus lessen
                    </p>
                    {['Herkennen van blafsoorten zodat je aan het type geblaf kan horen waarom hij blaft (angst, eenzaamheid, verveling, etc)', 'Stress signalen herkennen zodat je weet of je hond hoog of laag in zijn stress zit', '3 Kalmerende activiteiten waarmee je jouw hond kan helpen ontspannen als zijn stress level te hoog is'].map((item, i) => <div key={`bonus-${i}`} className="flex items-start gap-3" data-id="element-889">
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-890" />
                        <span className="text-sm text-gray-700" data-id="element-891">{item}</span>
                      </div>)}
                  </div>
                </div>

                {/* First pricing CTA */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-892">
                  <div className="bg-[#5ce0d2] text-[#1a2b4a] text-center py-3 px-4 font-bold text-sm" data-id="element-893">
                    Start met de Liefdevol Communiceren Methode
                  </div>
                  <div className="p-5 text-center" data-id="element-894">
                    <img src="https://cdn.magicpatterns.com/uploads/wdHvRUEhLbVnqomgf29M7C/d2e92536bec5d1aca3fcae847f833a85.jpg" alt="Liefdevol Communiceren Cursus Training" className="w-full h-auto object-contain mb-4 rounded-lg" data-id="element-895" />
                    <div className="text-[#e53e3e] font-black text-3xl mb-1" data-id="element-896">
                      Slechts €127
                    </div>
                    <div className="text-[#e53e3e] font-bold text-sm mb-3" data-id="element-897">
                      (Bespaar €70)
                    </div>
                    <p className="text-gray-600 text-sm mb-2" data-id="element-898">
                      Start met de cursus voor €127. Direct toegang. Begin met
                      stap 1 in slechts 2 minuten.
                    </p>
                    <p className="text-[#5ce0d2] font-bold text-sm mb-4" data-id="element-899">
                      Per direct toegang.
                    </p>
                    <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-g" className="block w-full bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-3 px-4 rounded-lg text-center transition-colors shadow-lg text-sm" data-id="element-900">
                      Krijg nu toegang!
                    </a>
                    <p className="text-xs text-gray-500 mt-2" data-id="element-901">
                      Met 365 dagen 100% geld-terug garantie
                    </p>
                  </div>
                </div>

                {/* Testimonials */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-902">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-903">
                    Dit is wat anderen zeggen
                  </div>
                  <div className="p-5 space-y-4" data-id="element-904">
                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-100" data-id="element-905">
                      <div className="flex text-[#ffb800] mb-2" data-id="element-906">
                        <Star className="w-4 h-4 fill-current" data-id="element-907" />
                        <Star className="w-4 h-4 fill-current" data-id="element-908" />
                        <Star className="w-4 h-4 fill-current" data-id="element-909" />
                        <Star className="w-4 h-4 fill-current" data-id="element-910" />
                        <Star className="w-4 h-4 fill-current" data-id="element-911" />
                      </div>
                      <p className="text-sm text-gray-700 italic mb-2" data-id="element-912">
                        "Sinds we de cursus volgen, is de band met Max zoveel
                        sterker geworden. We begrijpen elkaar eindelijk!"
                      </p>
                      <p className="text-xs font-bold text-[#1a2b4a]" data-id="element-913">
                        - Lisa & Max
                      </p>
                    </div>
                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-100" data-id="element-914">
                      <div className="flex text-[#ffb800] mb-2" data-id="element-915">
                        <Star className="w-4 h-4 fill-current" data-id="element-916" />
                        <Star className="w-4 h-4 fill-current" data-id="element-917" />
                        <Star className="w-4 h-4 fill-current" data-id="element-918" />
                        <Star className="w-4 h-4 fill-current" data-id="element-919" />
                        <Star className="w-4 h-4 fill-current" data-id="element-920" />
                      </div>
                      <p className="text-sm text-gray-700 italic mb-2" data-id="element-921">
                        "Ik dacht dat mijn hond gewoon koppig was, maar dankzij
                        Amee zie ik nu dat hij me iets probeerde te vertellen.
                        Een wereld van verschil."
                      </p>
                      <p className="text-xs font-bold text-[#1a2b4a]" data-id="element-922">
                        - Mark & Bella
                      </p>
                    </div>
                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-100" data-id="element-923">
                      <div className="flex text-[#ffb800] mb-2" data-id="element-924">
                        <Star className="w-4 h-4 fill-current" data-id="element-925" />
                        <Star className="w-4 h-4 fill-current" data-id="element-926" />
                        <Star className="w-4 h-4 fill-current" data-id="element-927" />
                        <Star className="w-4 h-4 fill-current" data-id="element-928" />
                        <Star className="w-4 h-4 fill-current" data-id="element-929" />
                      </div>
                      <p className="text-sm text-gray-700 italic mb-2" data-id="element-930">
                        "De rust in huis is teruggekeerd. Geen frustratie meer,
                        maar echte samenwerking. Bedankt!"
                      </p>
                      <p className="text-xs font-bold text-[#1a2b4a]" data-id="element-931">
                        - Sarah & Luna
                      </p>
                    </div>
                  </div>
                </div>

                {/* Second pricing CTA */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-932">
                  <div className="bg-[#5ce0d2] text-[#1a2b4a] text-center py-3 px-4 font-bold text-sm" data-id="element-933">
                    Start met de Liefdevol Communiceren Cursus
                  </div>
                  <div className="p-5 text-center" data-id="element-934">
                    <div className="text-[#e53e3e] font-black text-2xl mb-1" data-id="element-935">
                      Slechts €127 vandaag
                    </div>
                    <div className="text-[#e53e3e] font-bold text-sm mb-3" data-id="element-936">
                      (Bespaar €70)
                    </div>
                    <p className="text-gray-600 text-sm mb-4" data-id="element-937">
                      Start met de cursus voor €127. Direct toegang. Begin met
                      stap 1 in slechts 2 minuten.
                    </p>
                    <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-g" className="block w-full bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-3 px-4 rounded-lg text-center transition-colors shadow-lg text-sm" data-id="element-938">
                      Krijg nu toegang!
                    </a>
                    <p className="text-xs text-gray-500 mt-2" data-id="element-939">
                      Met 365 dagen 100% geld-terug garantie
                    </p>
                  </div>
                </div>

                {/* Bonussen */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-940">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-941">
                    Inclusief Bonussen
                  </div>
                  <div className="p-5 space-y-4" data-id="element-942">
                    {[{
                    title: '30 dagen community toegang',
                    desc: "Stuur vragen, foto's en videos naar onze experts, neem deel aan meerdere wekelijkse online coachingsessies en kom in contact met andere hondenbaasjes."
                  }, {
                    title: 'Printbare Stappenplannen',
                    desc: 'Handige, printbare overzichten van alle lichaamssignalen en kalmerende signalen om er altijd bij te kunnen pakken.'
                  }, {
                    title: 'Levenslange Toegang',
                    desc: 'Je krijgt levenslange toegang tot al het lesmateriaal, inclusief alle toekomstige updates van de cursus.'
                  }].map((bonus, i) => <div key={`b-${i}`} className="flex items-start gap-3" data-id="element-943">
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-944" />
                        <div data-id="element-945">
                          <p className="font-bold text-sm text-[#1a2b4a]" data-id="element-946">
                            {bonus.title}
                          </p>
                          <p className="text-xs text-gray-500" data-id="element-947">{bonus.desc}</p>
                        </div>
                      </div>)}
                  </div>
                </div>

                {/* Video Testimonials */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-948">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-949">
                    Video Testimonials & Interviews
                  </div>
                  <div className="p-5 space-y-4" data-id="element-950">
                    {['1158442858', '1158442995', '1158442918', '1158443130'].map(id => <div key={id} className="rounded-lg overflow-hidden shadow-sm" data-id="element-951">
                        <iframe src={`https://player.vimeo.com/video/${id}?badge=0&autopause=0&player_id=0&app_id=58479`} frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" className="w-full aspect-video" title={`Testimonial ${id}`} data-id="element-952"></iframe>
                      </div>)}
                  </div>
                </div>

                {/* Final CTA */}
                <div className="bg-[#e6f7f5] rounded-xl p-5 text-center border border-[#5ce0d2]" data-id="element-953">
                  <p className="font-bold text-[#1a2b4a] text-sm mb-3" data-id="element-954">
                    3 stappen tot je hond ontspannen alleen kan blijven
                  </p>
                  <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-g" className="block w-full bg-[#5ce0d2] hover:bg-[#4bc9bd] text-[#1a2b4a] font-bold py-3 px-4 rounded-lg text-center transition-colors shadow-md text-sm" data-id="element-955">
                    Start nu met de Liefdevol Communiceren Methode
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 19. GUARANTEE */}
      <section className="bg-[#1a2b4a] text-white py-16" data-id="element-956">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-957">
          <img src="https://cdn.magicpatterns.com/uploads/tPvpNvykR2KiCNK1pkG2LG/1a50ac51aa1d734ab9af0a73cc65b51b.png" alt="100% Money Back Guarantee" className="w-32 h-32 mx-auto mb-6 object-contain" data-id="element-958" />
          <h2 className="text-3xl md:text-4xl font-black mb-4 text-[#ffb800]" data-id="element-959">
            De BESTE Geld-Terug Garantie In De Wereld
          </h2>
          <h3 className="text-2xl font-bold mb-8" data-id="element-960">
            365 dagen niet-goed, geld-terug garantie:
          </h3>
          <div className="text-lg text-gray-300 leading-relaxed space-y-6 max-w-3xl mx-auto text-left" data-id="element-961">
            <p data-id="element-962">
              Kijk, laat me eerlijk tegen je zijn: Ik weet dat voordat ik ergens
              induik… …ik zelf ook wil weten wat ik koop en dat het wordt
              ondersteund door een sterke geld-terug-garantie. En ik wil dat jij
              je comfortabel voelt bij deze aankoop. Ook al is het maar €127 –
              jij hebt voor dat geld gewerkt en het telt.
            </p>
            <p data-id="element-963">
              Zoals mijn opa altijd zei: "Maak eerst een proefrit, voordat je de
              auto van het terrein afrijdt." Maar hier zit het verschil. Waar de
              meeste mensen je maximaal een garantie van 14 of 30 dagen zouden
              geven… ga ik iets doen wat je waarschijnlijk nog nooit hebt
              gezien.
            </p>
            <p className="font-bold text-white text-xl text-center py-4" data-id="element-964">
              Ik geef je 365 dagen om de Liefdevol Communiceren Cursus te
              bekijken en toe te passen.
            </p>
            <p data-id="element-965">
              Ja, je leest het goed. Je krijgt een heel JAAR om deze korte
              training te volgen en toe te passen wat je erin leert. Niet
              slechts een paar weken of een maand. En als je niet volledig
              overdonderd bent door wat je leert… Dan stuur je me gewoon een
              e-mail en vraag je op elk moment binnen die 365 dagen je geld
              terug. We storten je €127 direct terug en je mag toegang tot de
              cursus gratis houden.
            </p>
            <p className="text-center italic mt-8" data-id="element-966">
              Omdat je nu nog aan het gelezen ben, neem ik aan dat je klaar bent
              om te bestellen, dus met die gedachten...
            </p>
          </div>
        </div>
      </section>

      {/* 20. PRICING CTA */}
      <section className="bg-white py-16 border-b border-gray-200" data-id="element-967">
        <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-968">
          <h2 className="text-4xl font-black text-[#1a2b4a] mb-2" data-id="element-969">
            Vandaag voor €127
          </h2>
          <h3 className="text-2xl font-bold text-[#e53e3e] mb-6" data-id="element-970">
            (Bespaar €70)
          </h3>
          <img src="https://cdn.magicpatterns.com/uploads/cn6aNStyPs26sEQni2fyTV/Ontwerp_zonder_titel_(21).jpg" alt="Liefdevol Communiceren Stappenplan" className="w-full max-w-md mx-auto mb-8 mix-blend-multiply" data-id="element-971" />
          <p className="text-lg text-gray-600 mb-8" data-id="element-972">
            Start met de Liefdevol Communiceren Cursus voor{' '}
            <span className="line-through" data-id="element-973">€197</span> slechts €127! Direct
            toegang tot online lesmateriaal. Neem de eerste stap in 2 minuten.
          </p>
          <div className="max-w-md mx-auto" data-id="element-974">
            <CTAButton data-id="element-975" />
            <p className="text-sm text-gray-500 mt-4 font-bold" data-id="element-976">
              Met 365 dagen 100% geld terug garantie.
            </p>
          </div>
        </div>
      </section>

      {/* 21. WHAT YOU GET GRID */}
      <section className="bg-[#faf5eb] py-16" data-id="element-977">
        <div className="max-w-6xl mx-auto px-4" data-id="element-978">
          <h2 className="text-3xl font-black text-[#1a2b4a] text-center mb-12" data-id="element-979">
            Dit is wat je krijgt met de training
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-980">
            {[{
            title: 'Liefdevol Communiceren Cursus',
            desc: 'Volledige training in hoe je de Liefdevol Communiceren Methode inzet.',
            image: 'https://cdn.magicpatterns.com/uploads/d7mvv6jB1XyRHfPv1QLUbd/Verlatingangst_kernmethode_bonus_(2).png'
          }, {
            title: '30 dagen ondersteuning via Community',
            desc: "Stuur vragen, foto's en videos naar onze experts, neem deel aan meerdere wekelijkse online coachingsessies.",
            image: 'https://cdn.magicpatterns.com/uploads/8mzMhue5NATuWpex23cfs6/2.png'
          }, {
            title: 'Levenslange Toegang',
            desc: 'Je krijgt levenslange toegang tot al het lesmateriaal, inclusief alle toekomstige updates.',
            image: 'https://cdn.magicpatterns.com/uploads/5xTMXACWhxH6FRP25sk6Rf/4.png'
          }, {
            title: 'Printbare Stappenplannen',
            desc: 'Handige, printbare overzichten van alle lichaamssignalen en kalmerende signalen.',
            image: 'https://cdn.magicpatterns.com/uploads/dAT5SmJ1D7wjLPsXTfaXi4/3.png'
          }].map((item, i) => <div key={i} className="bg-white rounded-xl overflow-hidden shadow-md flex flex-col h-full" data-id="element-981">
                <div className="bg-[#5ce0d2] text-[#1a2b4a] font-bold text-center py-2 text-xs uppercase tracking-wider" data-id="element-982">
                  INBEGREPEN BIJ JE BESTELLING
                </div>
                <div className="p-6 flex-1 flex flex-col" data-id="element-983">
                  <div className="w-full h-48 rounded-lg mb-4 flex items-center justify-center overflow-hidden" data-id="element-984">
                    <img src={item.image} alt={item.title} className="w-full h-full object-contain" data-id="element-985" />
                  </div>
                  <h4 className="font-bold text-[#1a2b4a] mb-2 leading-tight" data-id="element-986">
                    {item.title}
                  </h4>
                  <p className="text-sm text-gray-600 mt-auto" data-id="element-987">{item.desc}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* 22. BOTTOM CTA BAR */}
      <div className="bg-[#ffb800] py-8 text-center px-4" data-id="element-988">
        <div className="max-w-md mx-auto" data-id="element-989">
          <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-g" className="block w-full bg-[#1a2b4a] hover:bg-black text-white font-bold py-4 px-4 rounded-lg text-xl transition-colors shadow-lg" data-id="element-990">
            Krijg nu toegang!
          </a>
          <p className="text-sm text-[#1a2b4a] mt-3 font-bold" data-id="element-991">
            Met 365 dagen 100% geld-terug garantie
          </p>
        </div>
      </div>

      {/* 24. TURID RUGAAS QUOTE */}
      <section className="bg-white py-16" data-id="element-992">
        <div className="max-w-4xl mx-auto px-4 flex flex-col md:flex-row items-center gap-8" data-id="element-993">
          <div className="flex-1 text-center md:text-left" data-id="element-994">
            <h2 className="text-2xl md:text-3xl font-bold text-[#1a2b4a] mb-6 leading-tight" data-id="element-995">
              Meestal zijn wij, de menselijke soort, degenen die conflicten
              creëren tussen onze honden en onszelf
            </h2>
            <p className="text-lg text-gray-700 mb-2" data-id="element-996">
              <strong data-id="element-997">Turid Rugaas</strong>, wereldberoemde Noorse
              hondentrainster, auteur en expert in hondentaal
            </p>
            <p className="text-xs text-gray-400 uppercase tracking-wide" data-id="element-998">
              DISCLAIMER: Dit is geen aanbeveling van Turid Rugaas
            </p>
          </div>
          <div className="w-48 h-48 flex-shrink-0" data-id="element-999">
            <img src="https://cdn.magicpatterns.com/uploads/5u3DrMLHNnG7KPDoQAwX5E/e34559c94a8bf7103f4c6cb20d81f245.jpg" alt="Turid Rugaas" className="w-full h-full object-cover rounded-xl shadow-lg grayscale" data-id="element-1000" />
          </div>
        </div>
      </section>

      {/* 25. FAQ */}
      <section className="bg-[#faf5eb] py-16" data-id="element-1001">
        <div className="max-w-5xl mx-auto px-4" data-id="element-1002">
          <h2 className="text-4xl font-black text-[#1a2b4a] text-center mb-16" data-id="element-1003">
            Veelgestelde vragen
          </h2>
          <div className="grid md:grid-cols-2 gap-x-12 gap-y-10" data-id="element-1004">
            {[{
            q: 'Ik wil dit, wat krijg ik exact?',
            a: 'Na je aankoop ontvang je een email met een inlogcode tot ons leerplatform. In dit platform vind je drie uitgebreide modules waarin je alles leert over de Liefdevol Communiceren Methode.'
          }, {
            q: 'Wat is de Liefdevol Communiceren Methode?',
            a: 'Dit is een nieuwe methode waarin je de taalbarrière tussen jou en je hond doorbreekt in plaats van je alleen maar te richten op commanderen. Wij gebruiken deze methode om jaarlijks bij honderden honden gedragsproblemen bij de kern aan te pakken en op te lossen.'
          }, {
            q: 'Kan ik meer hulp krijgen als ik dit wil?',
            a: 'Ja, er is een knop om in contact te komen met iemand van ons team die je meer kan uitleggen over onze 1-op-1 hulp.'
          }, {
            q: 'Wat maakt dit anders dan alle andere informatie online?',
            a: 'Alles wat je kan vinden gaat alleen maar over gehoorzaamheid en correcties. Met deze methode kijk je naar de taal die je hond spreekt, pak je de miscommunicatie bij de kern aan en ga je daarna pas samenwerken. Op deze manier heb je sneller, beter en blijvend resultaat.'
          }, {
            q: 'Voor wie is dit?',
            a: 'Dit is voor hondenbaasjes die de gedragsproblemen van hun hond nu voor eens en altijd willen oplossen en dit op een empatische, liefdevolle manier willen doen.'
          }, {
            q: 'Is er een garantie?',
            a: 'Ja, je krijgt een 365 dagen niet-goed, geld-terug garantie voor het geval je toch niet tevreden bent.'
          }].map((faq, i) => <div key={i} data-id="element-1005">
                <h4 className="font-bold text-xl text-[#1a2b4a] mb-3 flex items-start gap-3" data-id="element-1006">
                  <HelpCircle className="w-6 h-6 text-[#5ce0d2] flex-shrink-0 mt-0.5" data-id="element-1007" />
                  {faq.q}
                </h4>
                <p className="text-[#5ce0d2] pl-9 leading-relaxed" data-id="element-1008">{faq.a}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* WANDELINGEN-BEELD */}
      <section className="bg-[#faf5eb] py-12" data-id="element-1009">
        <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-1010">
          <p className="text-xl md:text-2xl text-gray-700 leading-relaxed font-medium" data-id="element-1011">
            Hoe vaak per dag laat jij je hond uit? Drie keer? Vier keer?
          </p>
          <p className="text-xl md:text-2xl text-gray-700 leading-relaxed font-medium mt-4" data-id="element-1012">
            Dat zijn{' '}
            <span className="font-black text-[#1a2b4a]" data-id="element-1013">
              honderden wandelingen per jaar
            </span>
            . Honderden momenten samen.
          </p>
          <p className="text-xl md:text-2xl text-gray-700 leading-relaxed font-medium mt-4" data-id="element-1014">
            Waarom zouden jullie al die momenten doorbrengen met frustratie en
            spanning, als het ook{' '}
            <span className="text-[#5ce0d2] font-bold" data-id="element-1015">
              ontspannen en verbonden
            </span>{' '}
            kan?
          </p>
          <p className="text-lg text-gray-500 mt-6 italic" data-id="element-1016">
            Eén kleine verandering in hoe jij communiceert, verandert élke
            wandeling. Elke ochtend. Elke avond. Voorgoed.
          </p>
        </div>
      </section>

      {/* 26. FINAL CTA */}
      <div className="bg-[#ffb800] py-12 text-center px-4" data-id="element-1017">
        <div className="max-w-md mx-auto" data-id="element-1018">
          <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-g" className="block w-full bg-transparent border-4 border-[#1a2b4a] text-[#1a2b4a] hover:bg-[#1a2b4a] hover:text-white font-black py-4 px-4 rounded-lg text-2xl transition-colors" data-id="element-1019">
            Start met deze cursus
          </a>
          <p className="text-sm text-[#1a2b4a] mt-3 font-bold" data-id="element-1020">
            Met 365 dagen 100% geld-terug garantie
          </p>
        </div>
      </div>

      {/* 27. FOOTER */}
      <footer className="bg-[#111827] text-gray-400 py-12 text-xs leading-relaxed text-center px-4" data-id="element-1021">
        <div className="max-w-5xl mx-auto space-y-6" data-id="element-1022">
          <p className="font-bold text-white mb-8" data-id="element-1023">
            This site is not a part of the Facebook website or Facebook Inc.
            Additionally, This site is NOT endorsed by Facebook in any way.
            FACEBOOK is a trademark of FACEBOOK, Inc.
          </p>

          <div className="flex flex-col md:flex-row justify-between items-center gap-6 border-y border-gray-800 py-8 mb-8" data-id="element-1024">
            <p className="font-bold text-white" data-id="element-1025">
              Copywriting van Stressless Dogs Nederland BV
            </p>
            <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-g" className="bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-3 px-8 rounded-lg text-lg transition-colors" data-id="element-1026">
              Start met de cursus.
            </a>
          </div>

          <p className="text-justify" data-id="element-1027">
            We can not and do not make any guarantees about your ability to get
            results or earn any money with our ideas, information, tools, or
            strategies. What we can guarantee is your satisfaction with our
            training. We give you a 30-day 100% satisfaction guarantee on the
            products we sell, so if you are not happy for any reason with the
            quality of our training, just ask for your money back. You should
            know that all products and services by our company are for
            educational and informational purposes only. Nothing on this page,
            any of our websites, or any of our content or curriculum is a
            promise or guarantee of results or future earnings, and we do not
            offer any legal, medical, tax or other professional advice. Any
            financial numbers referenced here, or on any of our sites, are
            illustrative of concepts only and should not be considered average
            earnings, exact earnings, or promises for actual or future
            performance. Use caution and always consult your accountant, lawyer
            or professional advisor before acting on this or any information
            related to a lifestyle change or your business or finances. You
            alone are responsible and accountable for your decisions, actions
            and results in life, and by your registration here you agree not to
            attempt to hold us liable for your decisions, actions or results, at
            any time, under any circumstance.
          </p>
        </div>
      </footer>

      {/* 23. STICKY BOTTOM BAR */}
      <div className="fixed bottom-0 left-0 right-0 z-50 bg-[#1a2b4a] border-t-4 border-[#5ce0d2] p-3 flex items-center justify-center shadow-[0_-4px_20px_rgba(0,0,0,0.3)]" data-id="element-1028">
        <div className="flex items-center justify-between md:justify-center gap-3 md:gap-8 w-full max-w-5xl" data-id="element-1029">
          <div className="flex items-center gap-3 md:gap-6" data-id="element-1030">
            <img src="https://cdn.magicpatterns.com/uploads/oxTbd4Fk83NKokLatjZK4s/Verlatingangst_kernmethode_bonus_(4).png" alt="Liefdevol Communiceren Boek" className="hidden md:block w-16 h-auto object-contain" data-id="element-1031" />
            <img src="https://cdn.magicpatterns.com/uploads/cRmnco8rsPRXFAp45VMFKA/Ontwerp_zonder_titel_(70).png" alt="Liefdevol Communiceren Cursus" className="w-16 md:w-24 h-auto object-contain" data-id="element-1032" />
            <div data-id="element-1033">
              <div className="text-white font-bold text-sm md:text-base leading-tight" data-id="element-1034">
                Liefdevol Communiceren Cursus
              </div>
              <div className="text-[#5ce0d2] font-black text-lg md:text-xl" data-id="element-1035">
                <span className="text-red-500 line-through decoration-[3px] mr-2" data-id="element-1036">
                  €197
                </span>
                €127
              </div>
            </div>
          </div>
          <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-g" className="bg-[#ffb800] text-[#1a2b4a] font-bold py-2 px-6 md:px-8 md:py-3 rounded-lg text-sm md:text-base shadow-md whitespace-nowrap" data-id="element-1037">
            Naar Stap #2
          </a>
        </div>
      </div>
    </div>;
}